import { render, staticRenderFns } from "./AnimeSearchView.vue?vue&type=template&id=619be348&"
import script from "./AnimeSearchView.vue?vue&type=script&lang=ts&"
export * from "./AnimeSearchView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports